import {
  RequestFormatter,
  TextRequestFormatter,
} from "../../../../services/request-formatter";
import { getParam } from "../../../../services/api/utils";

export const getSKUQuery = (spCode: string, productLineCode: string) => {
  return new RequestFormatter([
    new TextRequestFormatter({
      field: "sp_code",
      value: getParam(spCode),
    }),
    new TextRequestFormatter({
      field: "product_line__code",
      value: getParam(productLineCode),
    }),
  ]).toString();
};
